import orange from '@material-ui/core/colors/orange';

export const gstheme = {
  props: {
    MuiButtonBase: {
      disableRipple: true
    },
  },
  overrides: {
    MuiPickersCalendarHeader: {
      switchHeader: {
        color: '#13294B',
        fontWeight: 500,
        '& p': {
          fontWeight: 500
        }
      },
    },
    MuiInputBase: {
      root: {
        '&.Mui-focused': {
          '& .MuiSelect-select': {
            marginLeft: 1,
            marginRight: 1,
            outline: 'solid 2px black'
          }
        }
      }
    },
    MuiGrid: {
      "spacing-xs-2": {
        margin: '-8px',
        width: '100%'
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "12px",
        color: "white",
        maxWidth: 600,
        zIndex: 10000,
        backgroundColor: "#01579B"
      }
    },
    MuiSwitch: {
      switchBase: {
        '&.Mui-focusVisible > span': {
          outline: 'dashed 2px black'
        }
      }
    },
    MuiRadio: {
      root: {
        '&.Mui-focusVisible > span': {
          outline: 'dashed 2px black'
        }
      }
    },
    MuiCheckbox: {
      root: {
        '&.Mui-focusVisible > span': {
          outline: 'dashed 2px black'
        }
      }
    },
    MuiFab: {
      root: {
        '&:focus-visible': {
          outline: 'dashed 2px black',
          borderRadius: '4px'
        }
      }
    },
    MuiButton: {
      root: {
        '&:focus-visible': {
          outline: 'dashed 2px black',
          borderRadius: '4px'
        }
      },
      containedSecondary: {
        '&.Mui-disabled': {
          backgroundColor: '#eeeeee',
          boxShadow: '0px 1px 3px #00000029'
        },
        '@media print': {
          display: 'none'
        }
      }
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#00A9E0'
      }
    },
    MuiIconButton: {
      root: {
        borderRadius: '4px',
        color: '#616161',
        '&:focus-visible': {
          outline: 'dashed 2px black',
          borderRadius: '4px'
        }
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: '#9e9e9e'
      }
    }
  },
  "typography": {
    "useNextVariants": true,
    "bodyFontSize": "14px",
    "caption": {
      "display": 'block',
      "color": '#606060'
    }
  },
  "palette": {
    "common": {
      "black": "#000",
      "white": "#fff"
    },
    "background": {
      "paper": "#fff",
      "default": "#f5f5f5",
      "medium": "#eeeeee"
    },
    "border": {
      "main": "solid 1px #9e9e9e"
    },
    "primary": {
      "light": "#01579B",
      "main": "#13294B",
      "dark": "#0080B0",
      "contrastText": "#ffffff"
    },
    "secondary": {
      "light": "#00ff00",
      "main": "#97d700",
      "dark": "#84BC01",
      "contrastText": "#13294B"
    },
    "default": {
      "light": "#bbb",
      "main": "#aaa",
      "dark": "#888",
      "contrastText": "#000"
    },
    "error": {
      "light": "#00ff00",
      "main": "#DD2C00",
      "dark": "#00ff00",
      "contrastText": "#fff"
    },
    "text": {
      "primary": "#212121",
      "secondary": "rgba(0, 0, 0, 0.54)",
      "disabled": "#616161",
      "hint": "rgba(0, 0, 0, 0.38)",
    }
  }
};

export const globalStyles = {
  appIcon: {
    '&:hover': {
      cursor: 'pointer'
    },
    '&:focus-visible': {
      outline: 'dashed 2px white'
    }
  },
  selectedOption: {
    backgroundColor: 'rgba(1,87,155, 0.1)'
  },
  sidebarFull: {
    position: 'absolute',
    top: '65px',
    left: '97px',
    bottom: '0px',
    right: '0px',
    '@media print': {
      left: '20px'
    }
  },
  sidebarNarrow: {
    position: 'absolute',
    top: '65px',
    left: '291px',
    bottom: '0px',
    right: '0px',
    '@media print': {
      left: '20px'
    }
  },
  fullGrid: {
    margin: '0px'
  },
  errorHelp: {
    color: '#ce2900',
    margin: '0px 0px 6px 12px'
  },
  infoHelp: {
    fontSize: '12px',
    marginLeft: 8,
    lineHeight: '14px'
  },
  tableHeading: {
    fontWeight: 500,
    fontSize: '14px',
    padding: '6px',
    color: gstheme.palette.primary.main
  },
  tableHeadingPlain: {
    fontWeight: 500,
    fontSize: '14px',
    padding: '6px',
    color: gstheme.palette.primary.main
  },
  tableCell: {
    padding: '6px',
    wordBreak: 'break-word',
    verticalAlign: 'top',
    border: 'none'
  },
  infoCell: {
    padding: '6px',
    wordBreak: 'break-word',
    verticalAlign: 'middle',
    border: 'none'
  },
  infoCellNo: {
    padding: '6px',
    verticalAlign: 'middle',
    border: 'none'
  },
  tableCellText: {
    fontSize: 13
  },
  tableCellLine: {
    display: 'block'
  },
  infoRow: {
    borderBottom: 'solid 1px #f0f0f0'
  },
  stripedRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: gstheme.palette.background.medium
    },
    '&:nth-of-type(even)': {
      backgroundColor: 'white'
    }
  },
  shadedRow: {
    backgroundColor: gstheme.palette.background.medium
  },
  showing: {
    fontSize: '12px',
    color: gstheme.palette.primary.main,
    '@media print': {
      display: 'none'
    }
  },
  datepicker: {
    '& div': {
      backgroundColor: 'white'
    }
  },
  datatype: {
    backgroundColor: gstheme.palette.primary.main,
    marginLeft: '-6px',
    fontSize: '12px',
    marginRight: '12px',
    whiteSpace: 'nowrap',
    width: '60px',
    textAlign: 'center',
    color: 'white',
    padding: '4px',
    borderRadius: '4px'
  },
  back: {
    zIndex: -1000,
    position: 'fixed',
    backgroundColor: '#f5f5f5',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  primaryAvatar: {
    color: '#13294B',
    fontFamily: 'rajdhani',
    fontSize: '24px',
    backgroundColor: '#97D700'
  },
  widePrimaryAvatar: {
    color: '#13294B',
    fontFamily: 'rajdhani',
    fontSize: '24px',
    width: '68px',
    borderRadius: 22,
    backgroundColor: '#97D700'
  },
  smallPrimaryAvatar: {
    color: '#13294B',
    fontFamily: 'rajdhani',
    fontSize: '14px',
    height: '29px',
    width: '29px',
    backgroundColor: '#97D700'
  },
  wideSmallPrimaryAvatar: {
    color: '#13294B',
    fontFamily: 'rajdhani',
    fontSize: '14px',
    height: '29px',
    width: '44px',
    borderRadius: 14,
    backgroundColor: '#97D700'
  },
  recentAvatar: {
    fontFamily: 'rajdhani',
    fontSize: '14px',
    height: '29px',
    width: '29px',
    backgroundColor: 'rgba(255, 111, 0, 0.25)'
  },
  componentList: {
    marginTop: '30px',
  },
  componentContainer: {
    paddingRight: 30,
    paddingBottom: 30
  },
  componentContainerContent: {
    backgroundColor: 'white',
    minHeight: 359,
    padding: '12px',
    borderRadius: '4px'
  },
  controlPanel: {
    float: 'left',
    backgroundColor: 'white',
    marginTop: '10px',
    borderRadius: '4px',
    height: 'calc(100% - 300px)',
    width: 340,
    padding: '0px 10px 10px 10px',
    zIndex: 10
  },
  controlPanelInner: {
    paddingTop: '8px'
  },
  controlPanelAdd: {
    clear: 'both',
    float: 'left',
    width: '30px',
    marginLeft: '-3px'
  },
  controlPanelSearch: {
    float: 'left',
    marginLeft: '3px',
    width: '294px',
    height: 60
  },
  controlPanelSearchWide: {
    float: 'left',
    marginLeft: '3px',
    width: '394px',
    height: 60
  },
  tree: {
    position: 'absolute',
    top: '166px',
    zIndex: 10,
    width: '340px',
    left: '0px',
    bottom: '0px',
    padding: '0px 10px',
    overflowX: 'scroll',
    overflowY: 'scroll',
    backgroundColor: 'white'
  },
  deepTree: {
    position: 'absolute',
    top: '176px',
    zIndex: 10,
    width: '340px',
    left: '0px',
    bottom: '0px',
    padding: '0px 10px',
    overflowX: 'scroll',
    overflowY: 'scroll',
    backgroundColor: 'white',
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  infoPanel: {
    position: 'absolute',
    top: '73px',
    left: '380px',
    right: '10px',
    bottom: '0px',
    backgroundColor: 'white',
    borderRadius: '4px',
    marginRight: '20px',
    paddingTop: '5px',
    paddingRight: '10px',
    overflowX: 'hidden',
    overflowY: 'scroll'
  },
  viewLanguagePanel: {
    position: 'absolute',
    top: '5px',
    minWidth: '100px',
    right: '30px'
  },
  dashboardAdd: {
    textAlign: 'right',
    marginBottom: '20px',
    minHeight: 40
  },
  dashboardPanel: {
    position: 'absolute',
    top: '25px',
    left: '380px',
    right: '10px',
    bottom: '0px',
    backgroundColor: 'transparent',
    borderRadius: '4px',
    marginRight: '20px',
    paddingTop: '5px',
    paddingRight: '10px',
    overflowX: 'scroll',
    overflowY: 'scroll'
  },
  hideLegend: {
    position: "absolute",
    clip: "rect(0 0 0 0)"
  },
  linkText: {
    color: '#0066CC',
    fontSize: '12px',
    display: 'inline-block',
    minWidth: '25px',
    '&:visited': {
      color: '#0066CC'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  actionButton: {
    color: '#97D700',
  },
  chip: {
    color: 'white',
    marginRight: 10,
    marginBottom: 10,
    maxWidth: '100%',
    backgroundColor: gstheme.palette.primary.main,
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  chipAdditional: {
    color: 'white',
    marginRight: 10,
    marginBottom: 10,
    maxWidth: '100%',
    backgroundColor: gstheme.palette.primary.main,
    '&:focus-visible': {
      outline: 'dashed 2px black'
    },
    '& .MuiChip-label': {
      transform: 'translateY(-4px)'
    }
  },
  compactChip: {
    color: 'white',
    marginRight: 10,
    marginBottom: 6,
    maxWidth: '100%',
    backgroundColor: gstheme.palette.primary.main,
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  compactChipAdditional: {
    color: 'white',
    marginRight: 10,
    marginBottom: 6,
    maxWidth: '100%',
    backgroundColor: gstheme.palette.primary.main,
    '&:focus-visible': {
      outline: 'dashed 2px black'
    },
    '& .MuiChip-label': {
      transform: 'translateY(-4px)'
    }
  },
  noMarginChip: {
    color: 'white',
    marginRight: 0,
    marginBottom: 0,
    maxWidth: '100%',
    backgroundColor: gstheme.palette.primary.main,
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  noMarginChipAdditional: {
    color: 'white',
    marginRight: 0,
    marginBottom: 0,
    maxWidth: '100%',
    backgroundColor: gstheme.palette.primary.main,
    '&:focus-visible': {
      outline: 'dashed 2px black'
    },
    '& .MuiChip-label': {
      transform: 'translateY(-4px)'
    }
  },
  xlLabelChip: {
    color: 'white',
    marginRight: 10,
    marginBottom: 10,
    maxWidth: '100%',
    backgroundColor: '#0066CC',
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  labelChip: {
    color: '#616161',
    marginRight: 10,
    paddingLeft: '4px',
    marginBottom: 10,
    maxWidth: '100%',
    border: 'solid 1px #9E9E9E',
    backgroundColor: 'transparent',
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  activeChip: {
    color: '#616161',
    marginRight: 10,
    maxWidth: '100%',
    marginBottom: 10,
    border: 'solid 1px #9E9E9E',
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'white'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  inactiveChip: {
    color: '#616161',
    maxWidth: '100%',
    marginRight: 10,
    marginBottom: 10,
    border: 'solid 1px #9E9E9E',
    backgroundColor: 'transparent',
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  inputIcon: {
    color: '#616161',
    maxHeight: '16px'
  },
  inputIconHighlighted: {
    color: gstheme.palette.primary.light,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  fieldAvatar: {
    height: '24px',
    width: '24px',
    fontSize: '.75rem',
    color: 'white',
    backgroundColor: '#01579B'
  },
  invertedFieldAvatar: {
    height: '24px',
    width: '24px',
    fontSize: '.75rem',
    fontWeight: 500,
    color: '#01579B',
    backgroundColor: 'white'
  },
  breadcrumb: {
    fontSize: '12px',
    marginTop: '8px',
    marginBottom: '8px'
  },
  crumb: {
    display: 'inline-block',
    paddingTop: '3px',
    overflow: 'hidden',
    verticalAlign: 'initial',
    color: gstheme.palette.text.disabled,
    maxWidth: '200px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  layoutTitle: {
    display: 'inline-block',
    overflow: 'hidden',
    marginTop: '-4px',
    color: gstheme.palette.primary.main,
    marginBottom: '2px',
    maxWidth: '365px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontFamily: 'rajdhani',
    fontWeight: 500,
    fontSize: '24px',
    '@media print': {
      marginTop: '24px'
    }
  },
  componentMainHeading: {
    fontFamily: 'rajdhani',
    color: gstheme.palette.primary.main,
    fontWeight: 500,
    fontSize: '24px',
    margin: '0px',
    padding: '0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  mainHeadingLarge: {
    fontFamily: 'rajdhani',
    color: gstheme.palette.primary.main,
    fontWeight: 500,
    fontSize: '30px'
  },
  mainHeading: {
    fontFamily: 'rajdhani',
    color: gstheme.palette.primary.main,
    fontWeight: 500,
    fontSize: '24px'
  },
  mainHeadingLight: {
    fontFamily: 'rajdhani',
    color: 'white',
    fontWeight: 500,
    fontSize: '24px'
  },
  subMainHeading: {
    fontFamily: 'rajdhani',
    fontWeight: 500,
    color: gstheme.palette.primary.main,
    fontSize: '20px',
    margin: '0px 0px 6px 0px',
    padding: 0
  },
  mainHeadingSecondary: {
    fontFamily: 'rajdhani',
    color: gstheme.palette.secondary.main,
    fontWeight: 500,
    fontSize: '24px'
  },
  subHeading: {
    fontWeight: 500,
    color: gstheme.palette.primary.main,
    fontSize: '14px',
    margin: 0,
    padding: 0
  },
  subHeadingLarge: {
    fontWeight: 500,
    color: gstheme.palette.primary.main,
    fontSize: '16px',
    margin: 0,
    padding: 0
  },
  subSubHeading: {
    fontWeight: 'normal',
    color: '#000000',
    fontSize: '14px',
    margin: 0,
    padding: 0
  },
  statistic: {
    fontFamily: 'rajdhani',
    color: gstheme.palette.primary.main,
    borderBottom: 'none',
    fontWeight: 500,
    padding: '0px',
    fontSize: '30px'
  },
  button: {
    boxShadow: '0px 1px 3px #00000029',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: '6px',
    '&:hover': {
      boxShadow: '0px 3px 6px #00000029'
    }
  },
  smallButtonIcon: {
    marginLeft: 0
  },
  secondaryButton: {
    boxShadow: 'none',
    borderColor: gstheme.palette.secondary.main,
    borderStyle: 'solid',
    borderWidth: '1px',
    color: '#50832C',
    backgroundColor: 'white',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: '6px',
    '&:hover': {
      boxShadow: '0px 3px 6px #00000029',
      backgroundColor: '#97D70066'
    }
  },
  standardText: {
    fontWeight: 400,
    color: '#212121'
  },
  detailInfo: {
    height: 'calc(100% - 22px)',
    padding: 12,
    border: 'solid 1px #ddd',
    backgroundColor: '#F5F5F5'
  },
  formLabel: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: '2px',
    color: gstheme.palette.primary.main
  },
  compactCheckbox: {
    padding: '3px 12px'
  },
  formLabelInline: {
    fontSize: 14,
    fontWeight: 500,
    marginLeft: 2,
    color: gstheme.palette.primary.main
  },
  formLabelInlineLightLarge: {
    fontSize: 14,
    fontWeight: 400,
    marginLeft: 2,
    color: gstheme.palette.primary.main
  },
  formLabelInlineLight: {
    fontSize: 12,
    fontWeight: 400,
    marginLeft: 2,
    color: gstheme.palette.primary.main
  },
  inputLabel: {
    fontSize: 14,
    backgroundColor: 'white'
  },
  numberInputLabel: {
    fontSize: 14,
    width: 80,
    backgroundColor: 'white'
  },
  inputLabelDrop: {
    fontSize: 14,
    backgroundColor: 'white',
    paddingRight: 2,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  basicReadField: {
    fontSize: 14,
    backgroundColor: 'white',
    color: gstheme.palette.text.disabled
  },
  dialog: {
    minWidth: '300px'
  },
  smallDialog: {
    minWidth: '300px',
    maxWidth: '400px'
  },
  mediumDialog: {
    minWidth: '300px',
    maxWidth: '500px'
  },
  largeDialog: {
    minWidth: '500px',
    maxWidth: '700px'
  },
  xLargeDialog: {
    width: '1000px'
  },
  mediumDialogOverflow: {
    minWidth: '300px',
    maxWidth: '500px',
    overflow: 'visible'
  },
  dialogActions: {
    marginRight: '16px',
    marginBottom: '16px',
    marginLeft: '16px'
  },
  dropTarget: {
    backgroundColor: orange[200],
    borderRadius: '5px'
  },
  header: {
    backgroundColor: '#13294B',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: -1
  },
  backgroundBody: {
    backgroundColor: '#13294B',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: -100
  },
  halfHeader: {
    backgroundColor: '#13294B',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'fixed',
    top: 0,
    width: '50%',
    height: '100%',
    zIndex: -1
  },
  heading: {
    margin: '5px 0 0px 20px',
    padding: 0,
    color: 'white',
    fontSize: '1.5rem',
    fontWeight: 'normal'
  },
  halfHeading: {
    position: 'absolute',
    top: 200,
    left: 'calc(50% - 250px)',
    padding: 0,
    color: 'white',
    height: 100,
    fontSize: '1.5rem',
    fontWeight: 'normal'
  },
  logo: {
    position: 'absolute',
    top: '8px',
    left: '40px',
    height: 50
  },
  largeLogo: {
    position: 'absolute',
    left: 0,
    height: 120
  },
  largeLogoXS: {
    position: 'relative',
    height: 'auto',
    top: 50,
    width: '100%'
  },
  info: {
    margin: '10px 0 10px 0',
    fontStyle: 'italic'
  },
  views: {
    margin: '-12px -10px 0px -10px'
  },
  viewOnly: {
    color: gstheme.palette.text.disabled,
    display: 'inline-block',
    marginLeft: 10
  },
  grafsync: {
    marginTop: 0,
    marginLeft: 90,
    display: 'block'
  },
  strapline: {
    fontFamily: 'Rajdhani',
    marginLeft: 85,
    marginTop: 50,
    fontSize: '1rem',
    display: 'block'
  },
  leftPanel: {
    left: 20,
    width: "calc(32.5% - 20px)",
    paddingRight: 20,
    position: 'absolute',
    bottom: 0,
    top: 140,
    overflowX: 'hidden',
    overflowY: 'scroll'
  },
  rightPanel: {
    right: 0,
    bottom: 0,
    top: 140,
    padding: 10,
    overflowX: 'hidden',
    overflowY: 'scroll',
    width: "calc(62% - 10px)",
    position: 'absolute'
  },
  gsCard: {
    fontWeight: 500,
    boxShadow: 'none',
    borderBottom: 'solid 1px #eeeeee',
    '&:first-child': {
      borderTop: 'solid 1px #eeeeee',
    },
    '& .gsCardStatus': {
      color: '#616161',
      marginLeft: 6,
      fontSize: '14px',
      fontWeight: '400'
    },
    '&:hover': {
      backgroundColor: gstheme.palette.primary.light,
      color: 'white',
      cursor: 'pointer',
      '& .gsCardStatus': {
        color: 'white'
      }
    },
    '&:focus-visible': {
      outline: 'dashed 2px black',
      borderRadius: '4px'
    }
  },
  gsSelectedCard: {
    fontWeight: 500,
    boxShadow: 'none',
    opacity: 0.8,
    backgroundColor: gstheme.palette.primary.light,
    borderBottom: 'solid 1px #eeeeee',
    '&:first-child': {
      borderTop: 'solid 1px #eeeeee',
    },
    color: 'white',
    '& .gsCardStatus': {
      marginLeft: 6,
      fontSize: '14px',
      fontWeight: '400',
      color: 'white'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black',
      borderRadius: '4px'
    }
  },
  gsRecentCard: {
    fontWeight: 500,
    boxShadow: 'none',
    borderBottom: 'solid 1px #eeeeee',
    '&:first-child': {
      borderTop: 'solid 1px #eeeeee',
    }
  },
  gsCardInner: {
    alignItems: 'flex-start',
    padding: '12px'
  },
  gsCardHeader: {
    fontWeight: 500,
    paddingTop: '2px',
    fontSize: '16px'
  },
  formSelectorLabel: {
    fontSize: 16,
    color: gstheme.palette.primary.main,
    '@media print': {
      display: 'none'
    }
  },
  inputLinkLabel: {
    fontSize: 14,
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  inputLabelShrink: {
    fontSize: '1em'
  },
  dialogText: {
    fontSize: 14,
    color: '#212121',
    overflowWrap: 'break-word'
  },
  smallDialogText: {
    fontSize: 12,
    color: '#616161',
    overflowWrap: 'break-word'
  },
  listItem: {
    fontSize: 14
  },
  paper: {
    overflow: 'visible'
  },
  list: {
    maxHeight: 120
  },
  results: {
    boxShadow: ' 0 10px 10px rgba(0, 0, 0, 0.3)',
    border: 'solid 1px #e0e0e0',
    position: 'relative',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    marginTop: -5,
    width: 'calc(100% - 12px)',
    marginLeft: 5,
    zIndex: 20,
    backgroundColor: '#ffffff'
  },
  result: {
    alignItems: 'flex-start',
    '&:hover': {
      backgroundColor: gstheme.palette.background.medium,
      cursor: 'pointer'
    }
  },
  invalidResult: {
    alignItems: 'flex-start',
    color: gstheme.palette.error.main,
    '&:hover': {
      backgroundColor: gstheme.palette.background.medium
    }
  },
  infoResult: {
    alignItems: 'flex-start',
  },
  resultIcon: {
    margin: '2px 0px 0px 0px',
    minWidth: '30px'
  },
  resultSecondIcon: {
    margin: '0px 0px 0px 0px',
    textAlign: 'right',
    minWidth: '30px'
  },
  invalidResultIcon: {
    color: gstheme.palette.error.main,
    margin: '0px',
    minWidth: '30px'
  },
  resultText: {
    margin: '2px 0px 0px 0px'
  },
  linkJump: {
    '&:hover': {
      backgroundColor: '#dddddd',
    }
  },
  existingResults: {
    boxShadow: '3px 3px 3px rgba(0, 0, 0, 0.3)',
    border: 'solid 1px #ccc',
    position: 'absolute',
    marginLeft: 15,
    borderRadius: '4px',
    marginRight: 30,
    zIndex: 20,
    maxWidth: 'calc(100% - 300px)',
    backgroundColor: '#ffffff'
  },
  existingResultsHeader: {
    color: gstheme.palette.primary.main,
    fontWeight: 500
  },
  smallIconButton: {
    padding: 0,
    maxWidth: '30px',
    maxHeight: '30px',
    minWidth: '30px',
    minHeight: '30px'
  },
  outerContainer: {
    padding: '20px 20px 0px 20px'
  },
  infoBox: {
    margin: '10px 0px',
    border: gstheme.palette.border.main,
    padding: '8px',
    borderRadius: '4px'
  },
  slatInner: {
    right: 0,
    width: 68,
    height: 30,
    marginLeft: -68,
  },
  slatButton: {
    display: 'inline-block',
    marginLeft: '4px',
    borderRadius: 5,
    backgroundColor: gstheme.palette.primary.main,
  },
  slat: {
    float: 'left',
    color: gstheme.palette.primary.main,
    fontSize: '14px',
    marginTop: "5px",
    wordBreak: 'break-word',
    width: 'calc(100% - 60px)'
  },
  selectedSlat: {
    float: 'left',
    color: 'white',
    fontSize: '14px',
    marginTop: "5px",
    wordBreak: 'break-word',
    width: 'calc(100% - 60px)'
  },
  slatIcon: {
    width: 23,
    verticalAlign: 'top',
    display: 'inline-block',
    marginTop: '8px',
    '&:hover': {
      cursor: 'pointer'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  slatStyle: {
    textDecoration: 'none',
    display: 'inline-block',
    border: 'solid 1px #ddd',
    borderRadius: '5px',
    padding: '3px 3px 3px 10px',
    marginTop: '0px',
    minHeight: '30px',
    marginBottom: '0px',
    marginLeft: 5,
    width: 'calc(100% - 55px)',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: gstheme.palette.primary.light + '1A'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  selectedSlatStyle: {
    textDecoration: 'none',
    backgroundColor: gstheme.palette.primary.light,
    display: 'inline-block',
    border: 'solid 1px #ddd',
    borderRadius: '5px',
    color: 'white',
    padding: '3px 3px 3px 10px',
    marginTop: '0px',
    minHeight: '30px',
    marginBottom: '0px',
    marginLeft: 5,
    width: 'calc(100% - 55px)',
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  altSlatStyle: {
    textDecoration: 'none',
    backgroundColor: '#f0f0f0',
    display: 'inline-block',
    border: 'solid 1px #ddd',
    borderRadius: '5px',
    padding: '3px 3px 3px 10px',
    marginTop: '0px',
    minHeight: '30px',
    marginBottom: '0px',
    marginLeft: 5,
    width: 'calc(100% - 55px)',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: gstheme.palette.primary.light + '1A'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  selectedAltSlatStyle: {
    textDecoration: 'none',
    color: gstheme.palette.primary.main,
    backgroundColor: '#cccccc',
    display: 'inline-block',
    border: 'solid 1px #ddd',
    borderRadius: '5px',
    padding: '3px 3px 3px 10px',
    marginTop: '0px',
    minHeight: '30px',
    marginBottom: '0px',
    marginLeft: 5,
    width: 'calc(100% - 55px)',
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  legalLink: {
    fontSize: 12,
    color: '#0066CC',
    textAlign: 'center',
    width: '100%',
    '&:hover': {
      cursor: 'pointer'
    },
    '&:focus-visible': {
      outline: 'dashed 2px black'
    }
  },
  fromGS: {
    color: gstheme.palette.text.disabled,
    fontSize: '12px'
  },
  accessHeading: {
    fontFamily: 'Rajdhani',
    fontWeight: 500,
    fontSize: '34px',
    marginTop: '12px'
  },
  accessHeadingHighlighted: {
    fontFamily: 'Rajdhani',
    fontWeight: 500,
    fontSize: '34px',
    marginTop: '12px',
    color: gstheme.palette.secondary.main
  },
  loginText: {
    marginTop: 8
  },
  loginSubHeading: {
    fontWeight: 500,
    color: gstheme.palette.primary.main,
    fontSize: '16px'
  },
  loginInput: {
    backgroundColor: 'white !important',
    fontSize: '16px'
  },
  loginEntry: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: '#eeeeee',
    padding: 12,
    marginTop: 8,
    borderRadius: '4px'
  },
  subscriptionCard: {
    float: 'left',
    marginRight: 20,
    padding: 14,
    height: 180,
    width: 'calc(100% - 48px)',
    minWidth: 200,
    maxWidth: 300,
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 12px 17px #00000024'
    }
  },
  unapprovedSubscriptionCard: {
    float: 'left',
    backgroundColor: '#eeeeee',
    marginRight: 20,
    padding: 14,
    height: 180,
    width: 'calc(100% - 48px)',
    minWidth: 200,
    maxWidth: 300,
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column'
  },
  activeSubscriptionCard: {
    float: 'left',
    marginRight: 20,
    padding: 14,
    height: 180,
    minWidth: 200,
    maxWidth: 300,
    width: 'calc(100% - 48px)',
    marginBottom: 20,
    backgroundColor: '#50832C',
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0px 12px 17px #00000024'
    }
  },
  treeOptions: {
    marginLeft: '30px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    width: '270px',
    marginBottom: '12px',
    padding: '0px 12px'
  },
  treeOptionsWide: {
    marginLeft: '30px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    width: '370px',
    marginBottom: '12px',
    padding: '0px 12px'
  },
  import: {
    backgroundColor: 'white',
    minHeight: '450px',
    overflow: 'auto',
    paddingLeft: '30px',
    paddingRight: '30px',
    paddingBottom: '30px'
  },
  infoBar: {
    position: 'absolute',
    left: 0,
    top: 64,
    right: 0,
    height: '38px',
    paddingLeft: 80
  },
  infoBarIcon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingTop: '6px'
  },
  infoBarAction: {
    display: 'block',
    float: 'right',
    paddingTop: 3,
    paddingRight: 30,
    cursor: 'pointer'
  },
  infoBarMessage: {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingTop: '2px',
    paddingLeft: 12
  },
  filterArea: {
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    padding: 4,
    '@media print': {
      display: 'none'
    }
  },
  parametersArea: {
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    padding: 4
  },
  drTitle: {
    fontWeight: 500,
    display: 'inline-block',
    width: 50
  },
  domainRange: {
    display: "Block",
    marginTop: 3,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontSize: "0.8em"
  },
  taskInfo: {
    fontSize: 12,
    letterSpacing: '0.36px',
    display: 'flex',
    padding: 12,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'left'
  },
  taskActionIcon: {
    '&:hover': {
      borderRadius: 4,
      backgroundColor: '#BDBDBD'
    }
  },
  taskIcon: {
    color: '#9E9E9E',
    height: 16,
    transform: 'translateY(-2px)',
    verticalAlign: 'bottom'
  },
  instruction: {
    color: '#000000',
    marginBottom: 6
  },
  optionsButton: {
    marginRight: 12,
    marginBottom: 12,
    display: 'inline-block'
  },
  completeData: {
    border: 'solid 2px #f0f0f0',
    borderRadius: 4,
    padding: 6,
    backgroundColor: '#d8d8d8'
  },
  completeDataDark: {
    border: 'solid 2px #f0f0f0',
    borderRadius: 4,
    padding: 6,
    backgroundColor: '#d8d8d8'
  },
  completeDataDarkTop: {
    borderRadius: 4,
    padding: 6,
    backgroundColor: '#d8d8d8'
  },
  incompleteData: {
    borderRadius: 4,
    padding: 6,
    backgroundColor: 'rgb(256, 102, 0, 0.2)'
  }
};
